import { Box, Typography } from "@mui/material"
import { useMetrics } from "../../../shared/context/metricsContext"
import { useTheme } from "@mui/material/styles"
import { useEffect } from "react"
import { Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);

export default function OtScheduledByState() {
    const theme = useTheme();
    const { otsWithTasksScheduledByStatus, loadingOtsWithTasksScheduledByStatus, getOtsWithTasksScheduledByStatus, currentLocation } = useMetrics();

    useEffect(() => {
        getOtsWithTasksScheduledByStatus();
    }, []);

    const estados = [
        { key: 'pending', name: 'Pendientes', color: '#e74c3c' },
        { key: 'in_process', name: 'En Proceso', color: '#3498db' },
        { key: 'review', name: 'En Revisión', color: '#f39c12' },
        { key: 'completed', name: 'Completadas', color: '#17a589' }
    ];

    const labels = estados.map(e => e.name);
    const dataValues = estados.map(e => {
        if (!otsWithTasksScheduledByStatus || !currentLocation) return 0;
        return otsWithTasksScheduledByStatus[currentLocation?.name]?.[e.key] ?? 0;
    });
    const backgroundColors = estados.map(e => e.color);

    const data = {
        labels,
        datasets: [
            {
                label: 'OTs Programadas',
                data: dataValues,
                backgroundColor: backgroundColors,
                categoryPercentage: 0.6,
                barPercentage: 0.7,
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            title: { display: false },
            datalabels: {
                color: '#fff',
                anchor: 'center',
                align: 'center',
                formatter: function(value) {
                    return value;
                },
                font: {
                    weight: 'bold',
                    size: 16
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    color: theme.palette.text.primary
                },
                grid: {
                    color: theme.palette.divider
                }
            },
            x: {
                ticks: {
                    color: theme.palette.text.primary
                },
                grid: {
                    color: theme.palette.divider
                }
            }
        }
    };

    return (
        <Box sx={{
            width: '100%',
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(2),
            boxShadow: theme.palette.shadow.default,
            borderRadius: theme.spacing(1),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Typography variant="body1" sx={{
                fontWeight: 'bold',
                fontSize: { xs: '0.9rem', sm: '1rem' },
                color: theme.palette.text.primary,
                mb: 2
            }}>Cantidad de OTs programadas por estado</Typography>
            <Bar data={data} options={options} />
        </Box>
    )
}